import { render, staticRenderFns } from "./StampaPezzo.vue?vue&type=template&id=346c0d3c&"
import script from "./StampaPezzo.vue?vue&type=script&lang=js&"
export * from "./StampaPezzo.vue?vue&type=script&lang=js&"
import style0 from "./StampaPezzo.vue?vue&type=style&index=0&id=346c0d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports